import { DsUserFront } from './ds-user-front.model';

export class DsNewUser {
  /**
   *
   */
  account_lid: string;

  /**
   *
   */
  account_firstname: string;

  /**
   *
   */
  account_lastname: string;

  /**
   *
   */
  account_email: string;

  /**
   *
   */
  sxd_admin: number;

  /**
   *
   */
  account_phonenumber: string;

  /**
   *
   * @param jsonData jsonData
   */
  constructor(jsonData: DsUserFront) {
    this.account_lid = jsonData.accountLid || this.account_lid;
    this.account_firstname = jsonData.accountFirstName || this.account_firstname;
    this.account_lastname = jsonData.accountLastName || this.account_lastname;
    this.account_email = jsonData.accountEmail || this.account_email;
    this.sxd_admin = jsonData.sxdAdmin || this.sxd_admin;
    this.account_phonenumber = jsonData.accountPhonenumber || this.account_phonenumber;
  }
}
